import React from 'react';
import { Text } from "@chakra-ui/react"
import { ICON_SIZE_MAPPING, ICON_CLASS_TO_PATH_MAPPING } from "./constants"
import { IconPropTypes } from "./IconPropTypes"
import '../../style/icon/icon.css'

export const Icon = ({ size, className, ...props }: IconPropTypes.IconProps) => {
    const paths = ICON_CLASS_TO_PATH_MAPPING[className] || [];
    return (
        <Text as="span" fontSize={ICON_SIZE_MAPPING[size]} className={className} {...props} >
            { paths.map(path=> (<span className={path} />)) }
        </Text>
    )
}
